import {Component, OnInit, ViewContainerRef, Renderer2, Input, EventEmitter, Output} from '@angular/core';
import { NdmsFormControlComponent, ControlState, CheckRadioType } from '../ndms-form-control/ndms-form-control.component';
import { FormBuilder, FormArray, FormControl, AbstractControl } from '@angular/forms';
import { LookupViewModel } from '../../view-models/lookup.view-model';

@Component({
  selector: 'ndms-checkbox',
  templateUrl: './ndms-checkbox.component.html',
  styleUrls: ['./ndms-checkbox.component.scss']
})
export class NdmsCheckboxComponent extends NdmsFormControlComponent implements OnInit {

  @Input() displayType: string;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  CheckRadioType = CheckRadioType;
  constructor(viewContainerRef: ViewContainerRef) {
    super(viewContainerRef);
  }

  getCheckboxListTemplate(): CheckRadioType {
    if(!this.displayType) {
        return CheckRadioType.Inline;
    }

    switch(this.displayType) {
      case "stacked":
        return CheckRadioType.Stacked;
      case "inline":
      default:
        return CheckRadioType.Inline;
    }
  }
  changeCheckbox($event){
    //this.change.emit($event);
  }
  initChecked(item: LookupViewModel) {
    return (this.hasFormComponent.form.get(this.array) as FormArray).controls.filter(control =>
      control.value.key === item.key).length;
  }

  onCheckedChange(event, item) {
    let formArray: FormArray = this.hasFormComponent.form.get(this.array) as FormArray;

    if (event.target.checked) {
      formArray.push(new FormControl(item));
    } else {
      let i: number = 0;

      formArray.controls.forEach((ctrl: AbstractControl) => {
        if ((ctrl.value as LookupViewModel).key == event.target.value) {
          // Remove the unselected element from the arrayForm
          formArray.removeAt(i);
          return;
        }

        i++;
      });
    }
  }
}
